// jQueryプラグイン
import anime from 'animejs/lib/anime.es.js';
//トップページ　キービジュアルスライダー
import slick from 'slick-carousel';
export function idxFunc() {
  let indexTop = $('#indexTop').length;

  let resizecheck = $('#responsibleCheck').width();
  let accordionBtn = $('.accordionBtn');

  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(indexTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

    $('.mainviewSlideArea').slick({
      loop: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 5000,
      dots: false,
      arrows: false,
      fade: true,
      infinite: true,
    });

    $('.newsSlideArea').slick({
      loop: true,
      speed: 400,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      fade: false,
      infinite: true,
      prevArrow: '<img src="/images/common/slide_arrows_prev.svg" class="slide-arrow next-arrow">',
      nextArrow: '<img src="/images/common/slide_arrows_next.svg" class="slide-arrow prev-arrow">',
      responsive: [
        {
          breakpoint: 768, // 399px以下のサイズに適用
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
    
    function txtParaRight(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((elemO - winScroll) / 14) + 'px)');
        }
      });
    }
    function txtParaLeft(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((winScroll - elemO) / 14) + 'px)');
        }
      });
    }

    function indexCommonAnimeFunc() {
      $('.commonTwoColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonTwoColumnTit').hasClass('isShow')) {
                $(this).find('.commonTwoColumnTit').addClass('isShow');
                $(this).find('.commonTwoColumnTxt').addClass('isShow');
                $(this).find('.btn01').addClass('isShow');
              }
              if ($('.btn02').length) {
                $(this).find('.btn02').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }
    function indexCareersAnimeFunc() {
      $('.careersArea').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.img').hasClass('isShow')) {
              $(this).find('.img').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.careersAreaTit').hasClass('isShow')) {
                $(this).find('.careersAreaTit').addClass('isShow');
                $(this).find('.careersAreaTxt').addClass('isShow');
                $(this).find('.btn01').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }

    let graphAnimationFlag01 = false;
    let graphAnimationFlag02 = false;
    let graphAnimationFlag03 = false;

    let scrHightNum;

    function numbersAreaFunc(){
      if (resizecheck == '2') {
        scrHightNum = 0;
      } else if (resizecheck == '1') {
        scrHightNum = 200;
      }

      $('.numbersList01').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.peopleNum');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag01) {
            graphAnimationFlag01 = true;
            anime({
              targets: roundDateLogEl01,
              innerHTML: [0, 180],
              easing: 'linear',
              duration: 1000,
              delay: 100,
              round: 1 // Will round the animated value to 1 decimal
            });
          }
        }
      });
      $('.numbersList02').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl02 = document.querySelector('.countriesNum');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag02) {
            graphAnimationFlag02 = true;
            anime({
              targets: roundDateLogEl02,
              innerHTML: [0, 73],
              easing: 'linear',
              duration: 1000,
              delay: 100,
              round: 1 // Will round the animated value to 1 decimal
            });
          }
        }
      });
      $('.numbersList03').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl03 = document.querySelector('.shippedNum');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag03) {
            graphAnimationFlag03 = true;
            anime({
              targets: roundDateLogEl03,
              innerHTML: [0, 162],
              easing: 'linear',
              duration: 1000,
              delay: 100,
              round: 1 // Will round the animated value to 1 decimal
            });
          }
        }
      });
    }

    indexCommonAnimeFunc();
    indexCareersAnimeFunc();
    numbersAreaFunc();

    $(window).on('load scroll', function () {
      txtParaRight('.ourDecoTxt');
      txtParaRight('.peopleDecoTxt');
      txtParaRight('.careersDecoTxt');

      txtParaLeft('.creativityDecoTxt');
      txtParaLeft('.numbersDecoTxt');
      txtParaLeft('.servicesDecoTxt');

      indexCommonAnimeFunc();
      indexCareersAnimeFunc();
      numbersAreaFunc();
    });
  }
}